var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1872 1.87317C13.4801 1.58028 13.4801 1.10541 13.1872 0.812513C12.8943 0.51962 12.4194 0.51962 12.1265 0.812513L13.1872 1.87317ZM0.81281 12.1262C0.519916 12.4191 0.519916 12.894 0.81281 13.1869C1.1057 13.4798 1.58058 13.4798 1.87347 13.1869L0.81281 12.1262ZM12.1265 13.1868C12.4194 13.4797 12.8943 13.4797 13.1872 13.1868C13.4801 12.8939 13.4801 12.419 13.1872 12.1262L12.1265 13.1868ZM1.87347 0.812443C1.58058 0.51955 1.1057 0.51955 0.81281 0.812443C0.519916 1.10534 0.519916 1.58021 0.812809 1.8731L1.87347 0.812443ZM12.1265 0.812513L0.81281 12.1262L1.87347 13.1869L13.1872 1.87317L12.1265 0.812513ZM13.1872 12.1262L1.87347 0.812443L0.812809 1.8731L12.1265 13.1868L13.1872 12.1262Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCrossIcon);
export default __webpack_public_path__ + "static/media/gray-cross-icon.b97fad8e770eefe06e7216dbbc8c00a7.svg";
export { ForwardRef as ReactComponent };